import cartAddonInit from "./cart-addon";

// Select the node that will be observed for mutations
const drawerCart = document.getElementById("drawer-cart");

if (drawerCart) {
  // Callback function to execute when mutations are observed
  const observeDrawerCart = function (mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    for (const mutation of mutationsList) {
      const mutationTarget = mutation.target;
      const targetForm = mutationTarget.querySelector(".js-ajax-product-form");
      const productId = targetForm.dataset.productId;

      if (!targetForm.classList.contains("initialized")) {
        cartAddonInit(productId);
      }

      targetForm.classList.add("initialized");
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(observeDrawerCart);

  // Start observing the target node for configured mutations
  observer.observe(drawerCart, { childList: true });
}
